import React from 'react';
import Footer from "../components/Footer";
import Hero from "../components/Hero";

function ThankYouView() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <Hero/>
        <h2 className="text-2xl font-bold text-center text-gray-900 mb-12">
          I już! Udało się zapisać na otrzymywanie powiadomień.
        </h2>
      </div>
      <Footer/>
    </div>
  );
}

export default ThankYouView;
